import LicensePeriodShow from '@pages/licenses/LicenseShow'
import { beforeRouteEnterAction } from '@router/router.utils.js'

export default [
  {
    path: '/licenses/:id',
    name: 'license',
    component: LicensePeriodShow,
    props: true,
    meta: {
      actions: ['licenses/getSingle', 'licenses/getInlineEditingData', 'licensePeriods/getCreateFormData'],
      requiresAuth: true,
      hasSearchBar: true,
      pageTitle: 'Licenses',
      pathToLocalization: 'licenses.title'
    },
    beforeEnter: beforeRouteEnterAction
  }
]
